<template>
  <ubi-page-container class="DetailContactsPerPortal" wide-main-content>
    <template v-slot:page-actions>
      <el-button class="inline" @click="exporterContacts">
          {{ $t("portals.report.exportResults") }}
      </el-button>
    </template>
    <div v-loading="loading"
         :element-loading-text="$t('portals.list.chargementDonnees')">
      <ubi-panel :title="portal.nom" size="sm" v-if="portal != null">
        <template v-slot:left-column>
          <el-row>
            <el-col :lg="20" :md="12">
              <el-row>
                <el-col :lg="20" class="mb-3" v-if="nbCalls && nbCalls.infos">
                  <el-row>{{ $t("contacts.listGeneratedContactsTotal") }} <strong>{{nbContactsGeneresTotal + nbCallsCount}}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row v-if="possedeCallTracking === true">{{ $t("contacts.listGeneratedCallContactsTotal") }} <strong>{{ nbCallsCount }}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row v-if="possedeCallTracking === true">
                    <el-col>
                      {{ $t("contacts.listGeneratedEmailContactsTotal") }} <strong>{{nbContactsGeneresTotal}}</strong>
                      <br>
                      <br>
                    </el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.listAdsSentContacts") }} <strong>{{nbContactsGeneres}}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                  <el-row>{{ $t("contacts.listAdsSent") }} <strong>{{nbAnnonces}}/{{totalAnnonces}}</strong></el-row>
                  <el-row>
                    <el-col> <br></el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="Panel-footer">
            <template>
              <el-collapse accordion>
                <el-collapse-item name="advanced" :title="$t('contacts.activityDistributionEmailContacts')">
                  <el-row>
                    <el-col :lg="10">
                      <div class="text-muted" style="text-align: center;">
                        <pie-chart v-if="graphDataTypesBiens != null" :chart-data="graphDataTypesBiens" :options="null" ></pie-chart>
                        <div v-else
                             style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                        <br>
                        {{ $t("contacts.listTablePropertyTypes") }}
                      </div>
                    </el-col>
                    <el-col :lg="10">
                      <div class="text-muted" style="text-align: center;">
                        <pie-chart v-if="graphDataTypesOffres != null" :chart-data="graphDataTypesOffres" :options="null"></pie-chart>
                        <div v-else
                             style="text-align: center;">{{ $t("contacts.activityDistributionNoData") }}</div>
                        <br>
                        {{ $t("contacts.listTableOfferTypes") }}
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </template>
          </div>
        </template>
        <template v-slot:right-column>
          <el-row>
            <el-col :lg="20">
              <div class="text-muted" style="text-align: center;">
                <el-image
                    :src="portal.logo"
                />
              </div>
            </el-col>
          </el-row>
        </template>
      </ubi-panel>
      <!-- Formulaires de recherche - les deux sont chargés au démarrage, affichés selon l'onglet -->
      <!-- Formulaire Mailtracking (affiché si pas de calltracking OU onglet Mailtracking) -->
      <ApiSearchForm
        v-show="!possedeCallTracking || activeName === 'Mailtracking'"
        :key="$route.fullPath + '-mailtracking'"
        route="contact/detail-contacts-portals/mailtracking"
        :business-domain="sitimmoUser.univers.toLowerCase()"
        :user-context="userContext"
        @search="handleSearchFromApi"
        @config-loaded="handleConfigLoaded"
        @ready="handleSearchFormReady"
      />
      <!-- Formulaire Calltracking (affiché uniquement si calltracking ET onglet Calltracking) -->
      <ApiSearchForm
        v-if="possedeCallTracking"
        v-show="activeName === 'Calltracking'"
        :key="$route.fullPath + '-calltracking'"
        route="contact/detail-contacts-portals/calltracking"
        :business-domain="sitimmoUser.univers.toLowerCase()"
        :user-context="userContext"
        @search="handleSearchFromApiCalls"
        @config-loaded="handleConfigLoaded"
        @ready="handleSearchFormReady"
      />

      <ubi-panel v-if="possedeCallTracking === false">
        <ubi-list-header slot="header"
                         :limits="limits"
                         :page.sync="page"
                         :limit.sync="limit"
                         :total="nbResults"
                         :sort.sync="sort"
                         :sortProperties="sortProperties">
        </ubi-list-header>
        <el-button type="mini" slot="actions" v-loading="loadingExport" @click="exporterContacts">
            {{ $t("contacts.exportResults") }}
        </el-button>
        <ubi-list-footer slot="footer" :limits="limits" :page.sync="page" :limit.sync="limit" :total="nbResults"></ubi-list-footer>
        <el-table ref="table" :data="contacts">
          <el-table-column type="expand">
            <template v-slot="{ row: result }">
              {{result.commentaire}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contacts.listColumnDateAndHour')" min-width="160">
            <template v-slot="{ row: result }">
              {{getDateMailTracking(result)}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contacts.listColumnAdReference')" min-width="150">
            <template v-slot="{ row: result }">
              {{result.reference}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contacts.listColumnCivilityLastnameFirstname')" min-width="200">
            <template v-slot="{ row: result }">
              {{result.identite}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contacts.listColumnEmail')" min-width="180">
            <template v-slot="{ row: result }">
              {{result.email}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contacts.listColumnPhoneNumber')" min-width="180">
            <template v-slot="{ row: result }">
              {{result.telephone}}
            </template>
          </el-table-column>
        </el-table>
      </ubi-panel>
      <template v-else>
        <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="Mailtracking" :label="$t('contacts.listTabMailtracking')">
            <ubi-panel>
              <ubi-list-header slot="header"
                               :limits="limits"
                               :page.sync="page"
                               :limit.sync="limit"
                               :total="nbResults"
                               :sort.sync="sort"
                               :sortProperties="sortProperties">
              </ubi-list-header>
              <el-button type="mini" slot="actions" v-loading="loadingExport" @click="exporterContacts">
                  {{ $t("contacts.exportResults") }}
              </el-button>
              <ubi-list-footer slot="footer" :limits="limits" :page.sync="page" :limit.sync="limit" :total="nbResults"></ubi-list-footer>
              <el-table ref="table" v-if="contacts" :data="contacts">
                <el-table-column type="expand">
                  <template v-slot="{ row: result }">
                    {{result.commentaire}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnDateAndHour')" min-width="160">
                  <template v-slot="{ row: result }">
                    {{getDateMailTracking(result)}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnAdReference')" min-width="150">
                  <template v-slot="{ row: result }">
                    {{result.reference}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnCivilityLastnameFirstname')" min-width="200">
                  <template v-slot="{ row: result }">
                    {{result.identite}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnEmail')" min-width="250">
                  <template v-slot="{ row: result }">
                    {{result.email}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnPhoneNumber')" min-width="180">
                  <template v-slot="{ row: result }">
                    {{result.telephone}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnScoring')" min-width="180" >
                  <template v-slot="{ row: result }">
                    <span v-if="result.scoring && result.scoring !== null">{{ result.scoring }} / {{ result.scoringTotal }}</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnFormLink')"  min-width="180" fixed="right">
                  <template v-slot="{ row: result }">
                    <span v-if="result.cryptId !== null"><a :href="getUrlLinkForm(result)" target="_blank">lien du formulaire</a></span>
                  </template>
                </el-table-column>
              </el-table>
            </ubi-panel>
          </el-tab-pane>
          <el-tab-pane name="Calltracking" :label="$t('contacts.listTabCalltracking')">
            <ubi-panel>
              <ubi-list-header slot="header"
                               :limits="limits"
                               :limit.sync="limit"
                               :page.sync="pageCalls"
                               :total="nbResultsCalls"
                               :sort.sync="sortCalls"
                               :sortProperties="sortPropertiesCalls">
              </ubi-list-header>
              <el-button type="mini" slot="actions" v-loading="exportLoader" @click="exporterContacts">
                  {{ $t("contacts.exportResults") }}
              </el-button>
              <ubi-list-footer slot="footer" :limits="limits" :page.sync="pageCalls" :limit.sync="limit" :total="nbResultsCalls"></ubi-list-footer>
              <el-table ref="table" v-if="calls" :data="calls.calls">
                <el-table-column :label="$t('contacts.listColumnDate')">
                  <template v-slot="{ row: result }">
                    {{getDateCallTracking(result)}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnPhoneNumber')">
                  <template v-slot="{ row: result }">
                    {{result.callerNumber}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnCallStatus')">
                  <template v-slot="{ row: result }">
                    {{ callStatus(result) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('contacts.listColumnCallDuration')">
                  <template v-slot="{ row: result }">
                    {{ convertDuration(result) }}
                  </template>
                </el-table-column>
              </el-table>
            </ubi-panel>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </ubi-page-container>
</template>

<style lang="scss">
@import "../../theme/_bootstrap.scss";

.DetailContactsPerPortal {
  /* Personnalisation du Panel de recherche : garder barre verte, supprimer ombre/bordures */
  ::v-deep .el-card.Panel.is-always-shadow {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    border-top: none !important;
    border: none !important;
    border-bottom: none !important;
  }

  /* Réduire le padding du Panel de 34px à 5px */
  ::v-deep .el-card.Panel.is-always-shadow .el-card__body {
    padding: 5px !important;
  }
}

.el-loading-spinner{
  top:10%!important;
}
</style>

<script>
import moment from 'moment'
import downloadexcel from 'vue-json-excel'
import { Collapse, CollapseItem, Divider, Tabs, TabPane } from 'element-ui'
import { mapState, mapMutations, mapGetters } from 'vuex'
import {
  getContactsPortailEnTete,
  getContactsPortail,
  getCalls,
  getNbCalls,
  getTotalNbCalls,
  exportContacts,
  exportCalls
} from '@/services/contacts'
import PieChart from '../../services/piechart'
import { getDiffuseurInfos } from '@/services/portals'
import ApiSearchForm from '@/components/search/ApiSearchForm.vue'
import { convertApiFiltersToStore } from '@/utils/filterConverter'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'
export default {
  name: 'DetailContactsPerPortal',
  inject: ['browserContext'],
  components: {
    UbiPanel,
    UbiPageContainer,
    downloadexcel,
    PieChart,
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    ApiSearchForm
  },
  data () {
    return {
      loading: false,
      offset: 0,
      portalId: this.$route.params.portal,
      loadingExport: false,
      portal: null,
      limits: [10, 10 * 2, 10 * 5, 10 * 10],
      enTete: null,
      nbResults: 0,
      nbResultsCalls: 0,
      nbCalls: 0,
      graphDataTypesBiens: null,
      graphDataTypesOffres: null,
      calls: null,
      sortProperties: {
        date: this.$t('general.sort.date'),
        reference: this.$t('general.sort.reference'),
        identite: this.$t('general.sort.contactName')
      },
      sortPropertiesCalls: {
        '-dateStarted': this.$t('general.sort.date'),
        '-callDuration': this.$t('general.sort.callDurationDecrease'),
        callDuration: this.$t('general.sort.callDurationIncrease'),
        callerNumber: this.$t('general.sort.callNumber')
      },
      nbContactsGeneres: 0,
      nbContactsGeneresTotal: 0,
      nbProspects: 0,
      nbAnnonces: 0,
      contacts: null,
      nbPortailsActifs: 0,
      totalAnnonces: 0,
      graphData: {},
      activeName: 'Mailtracking',
      filters: [],
      exportLoader: false
    }
  },
  computed: {
    ...mapState('detailContactsPerPortal', ['filter', 'results']),
    ...mapGetters(['getPickerOptionsShortcuts']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeCallTracking () {
      return getFromSnake(this.sitimmoUser, 'possede_call_tracking')
    },
    nbCallsCount () {
      return getTotalNbCalls(this.nbCalls)
    },
    pickerOptions () {
      return {
        shortcuts: this.getPickerOptionsShortcuts
      }
    },
    // === PROPRIÉTÉS POUR ApiSearchForm ===
    userContext () {
      return {
        userId: this.sitimmoUser.id,
        univers: this.sitimmoUser.univers,
        metier: this.sitimmoUser.metier,
        betaTesteur: this.sitimmoUser.betaTesteur || false,
        hasScoring: this.sitimmoUser.hasScoring || false,
        activeName: this.activeName // Permet de basculer les champs selon l'onglet actif
      }
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    },
    pageCalls: {
      get () {
        return this.filter.pageCalls
      },
      set (value) {
        this.setOffsetCalls((value - 1) * this.limit)
        this.setPageCalls(value)
        this.fetchList()
        return this.setPageCalls(value)
      }
    },
    sortCalls: {
      get () {
        return this.filter.sortCalls
      },
      set (value) {
        this.setSortCalls(value)
        this.setOffsetCalls(0)
        this.setPageCalls(1)
        this.fetchList()
        return this.setSortCalls(value)
      }
    }
  },
  beforeMount () {
    // this.filter.beforeContacts = this.$store.getters['donnees/getContactsDateBefore']
    // this.filter.afterContacts = this.$store.getters['donnees/getContactsDateAfter']
    this.activeName = this.filter.activeName
    // this.setSort('date');
    // this.setSearch('');
    this.fetchPortal()
    // Ne pas appeler fetchList() ici, ApiSearchForm le fera via handleSearchFormReady()
  },
  methods: {
    getDateCallTracking (result) {
      const dateStarted = result.dateStarted
      // Si on a aucune date
      if (!dateStarted) {
        return '—' // ou '' ou 'N/A'
      }
      return moment(dateStarted.date, 'YYYY-MM-DD HH:mm:ss.SSSSSS').format('DD/MM/YYYY HH:mm:ss')
    },
    getDateMailTracking (result) {
      const dateEnvoi = new Date(result.dateEnvoi)
      // Si on a aucune date
      if (!dateEnvoi) {
        return '—'
      }
      return moment(dateEnvoi).format('DD/MM/YYYY HH:mm:ss')
    },
    eventAnalytics (category) {
      this.$ga.event('contact_manager_portails', 'clic', category, this.sitimmoUser.id)
    },
    async getEnTete () {
      this.enTete = await (getContactsPortailEnTete(this.filter, this.portalId))

      if (this.enTete.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
    },
    getUrlLinkForm (result) {
      return `${processEnvConfig.VUE_APP_QUALIFORMA_URL}#/${result.cryptId}`
    },
    async fetchDataCallsExport () {
      this.exportLoader = true
      const res = await getCalls(this.filter, this.portal, true)
      const calls = []
      res.calls.forEach(async function (call) {
        const objCall = {}
        objCall.annonceur = call.annonceur
        objCall.answered = call.answered
        objCall.callDuration = call.callDuration
        objCall.calledNumber = call.calledNumber
        objCall.callerNumber = call.callerNumber
        objCall.date = call.date.date
        objCall.dateEnded = call.dateEnded.date
        objCall.dateStarted = call.dateStarted.date
        objCall.diffuseur = call.diffuseur
        objCall.id = call.id
        objCall.redirectionNumber = call.redirectionNumber
        objCall.ringDuration = call.ringDuration
        objCall.termination = call.termination
        objCall.trackingNumber = call.trackingNumber
        calls.push(objCall)
      }, this)
      this.exportLoader = false
      return calls
    },
    async exportCalls () {
      const res = await exportCalls(this.filter, this.portal, this.$t('contacts.filenameExportContactsPerPortal'))
      this.$message(res)
      this.loading = false
    },
    convertDate: function (date) {
      return 'Le ' + moment(date).format('DD/MM/YYYY à hh:mm:ss')
    },
    ...mapMutations('detailContactsPerPortal', [
      'setPage',
      'setPageCalls',
      'setLimit',
      'setSort',
      'setSortCalls',
      'setSearch',
      'setFilter',
      'addFilter',
      'setResults',
      'setOffset',
      'setOffsetCalls',
      'resetFilter',
      'setStatutAppel',
      'setSearchCalls',
      'setActiveName',
      'setPortalCodeName'
    ]),
    handleClose (done) {
      this.$confirm(this.$t('general.exitConfirmation'))
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    doFilter (type) {
      switch (type) {
        case 'reset':
          this.resetFilter()
          this.filter.hasScoring = null
          break
        case 'gratuits':
          this.filter.gratuit = true
          this.setFilter(this.filter)
          break
      }
      this.fetchList()
    },
    async fetchPortal () {
      const portalInfos = await (getDiffuseurInfos(this.portalId))
      if (portalInfos.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.portal = portalInfos.reponse
    },
    async fetchList () {
      // Ne commit au store global QUE si les dates sont définies
      if (this.filter.beforeContacts !== undefined && this.filter.beforeContacts !== null) {
        this.$store.commit('donnees/SET_CONTACTS_DATE_BEFORE', this.filter.beforeContacts)
      }
      if (this.filter.afterContacts !== undefined && this.filter.afterContacts !== null) {
        this.$store.commit('donnees/SET_CONTACTS_DATE_AFTER', this.filter.afterContacts)
      }
      // No need to interrupt promises when the router changes...
      this.loading = true
      await (this.getEnTete())
      this.nbContactsGeneres = this.enTete.infos.nbContactsGeneres
      this.nbContactsGeneresTotal = this.enTete.infos.nbContactsGeneresTotal
      this.nbAnnonces = this.enTete.infos.nbAnnonces
      this.totalAnnonces = this.enTete.infos.totalAnnonces
      this.nbProspects = this.enTete.infos.nbProspects
      this.nbPortailsActifs = this.enTete.infos.nbPortailsActifs
      const temp = await getContactsPortail(this.filter, this.portalId)
      if (temp.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }

      this.setResults(temp)
      this.nbCalls = await getNbCalls(this.filter, this.portal)
      if (this.nbCalls.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.calls = await getCalls(this.filter, this.portal)
      if (this.calls.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      this.nbResultsCalls = this.nbCallsCount
      this.nbResults = this.results.infos.total_items
      this.contacts = this.results.infos.contact_mailtracking

      const labelsTypesBiensTmp = Object.keys(this.enTete.infos.tabTypesObject)
      const labelsTypesBiens = []
      // On coupe les noms de labels trop grand.
      for (let i = 0; i < labelsTypesBiensTmp.length; i++) {
        if (labelsTypesBiensTmp[i].length >= 20) {
          labelsTypesBiens.push(labelsTypesBiensTmp[i].substr(0, 20) + '[...]')
        } else {
          labelsTypesBiens.push(labelsTypesBiensTmp[i])
        }
      }
      const valuesTypesBiens = Object.values(this.enTete.infos.tabTypesObject)
      this.graphDataTypesBiens = {
        labels: labelsTypesBiens,
        datasets: [{
          label: '# of Votes',
          data: valuesTypesBiens,
          borderWidth: 0,
          backgroundColor: ['rgba(255, 99, 132, 0.55)',
            'rgba(54, 162, 235, 0.55)',
            'rgba(255, 206, 86, 0.55)',
            'rgba(75, 192, 192, 0.55)',
            'rgba(153, 102, 255, 0.55)',
            'rgba(255, 159, 64, 0.55)']
        }]

      }
      if (valuesTypesBiens.length == 0) {
        this.graphDataTypesBiens = null
      }
      const labelsTypesOffresTmp = Object.keys(this.enTete.infos.tabTypesOffre)
      const labelsTypesOffres = []
      // On coupe les noms de labels trop grand.
      for (let i = 0; i < labelsTypesOffresTmp.length; i++) {
        if (labelsTypesOffresTmp[i].length >= 20) {
          labelsTypesOffres.push(labelsTypesOffresTmp[i].substr(0, 20) + '[...]')
        } else {
          labelsTypesOffres.push(labelsTypesOffresTmp[i])
        }
      }
      const valuesTypesOffres = Object.values(this.enTete.infos.tabTypesOffre)
      this.graphDataTypesOffres = {
        labels: labelsTypesOffres,
        datasets: [{
          label: '# of Votes',
          data: valuesTypesOffres,
          borderWidth: 0,
          backgroundColor: [
            'rgba(255, 206, 86, 0.55)',
            'rgba(75, 192, 192, 0.55)',
            'rgba(153, 102, 255, 0.55)',
            'rgba(255, 159, 64, 0.55)']
        }]

      }
      if (valuesTypesOffres.length == 0) {
        this.graphDataTypesOffres = null
      }
      this.loading = false
    },
    handleClick (tab, event) {
      this.setActiveName(this.activeName)
    },
    convertDuration (result) {
      const seconds = result.talkDuration ? result.talkDuration : result.callDuration
      return moment('1900-01-01 00:00:00').add(seconds, 'seconds').format('mm:ss')
    },
    callStatus (result) {
      let status = null
      if (result.answered === true) {
        status = this.$t('contacts.listTabCalltrackingCallAnswered')
      } else {
        status = this.$t('contacts.listTabCalltrackingCallMissed')
      }
      return status
    },
    async exporterContacts () {
      this.setPortalCodeName(this.portal.nom_de_code)
      if (this.activeName === 'Mailtracking') {
        this.eventAnalytics('export_contacts_mail')
        this.loadingExport = true
        const res = await exportContacts(this.filter)
        this.loadingExport = false
        this.$message(res)
      } else {
        this.loading = true
        const res = await exportCalls(this.filter, this.portal, this.$t('contacts.filenameExportContactsCalls'))
        this.$message(res)
        this.loading = false
      }
    },
    onHasScoringChange (value) {
      // Réinitialiser la pagination à la page 1 quand on change le filtre hasScoring
      this.setOffset(0)
      this.setPage(1)
      this.addFilter({ hasScoring: value })
      this.fetchList()
    },
    // === MÉTHODES POUR ApiSearchForm ===
    handleSearchFromApi (filters) {
      console.log('🔍 DetailContactsPerPortal - Filtres Mailtracking reçus:', filters)

      // Utiliser l'utilitaire de conversion (comme PostsListImmo)
      const convertedFilters = convertApiFiltersToStore(filters, {
        metier: this.sitimmoUser.metier
      })

      console.log('📝 DetailContactsPerPortal - Filtres Mailtracking convertis:', convertedFilters)

      this.addFilter(convertedFilters)

      this.fetchList()
    },
    handleSearchFromApiCalls (filters) {
      console.log('🔍 DetailContactsPerPortal - Filtres Calltracking reçus:', filters)

      // Utiliser l'utilitaire de conversion (comme PostsListImmo)
      const convertedFilters = convertApiFiltersToStore(filters, {
        metier: this.sitimmoUser.metier
      })

      // Mapper search vers searchCalls pour le calltracking
      if (convertedFilters.search !== undefined) {
        convertedFilters.searchCalls = convertedFilters.search
        delete convertedFilters.search
      }

      // Gérer le statut d'appel ('' par défaut pour "tous")
      if (convertedFilters.statutAppel === undefined) {
        convertedFilters.statutAppel = ''
      }

      console.log('📝 DetailContactsPerPortal - Filtres Calltracking convertis:', convertedFilters)

      this.addFilter(convertedFilters)

      this.fetchList()
    },
    handleConfigLoaded (config) {
      console.log('⚙️ DetailContactsPerPortal - Configuration chargée:', config)
    },
    handleSearchFormReady () {
      console.log('✅ DetailContactsPerPortal - Formulaire de recherche prêt')
      // Ne pas appeler fetchList() ici, ApiSearchForm va automatiquement émettre la recherche
    }
  }

}
</script>
<style>
.el-tab-pane {
  background-color: aliceblue;
}
.el-tabs__item.is-active {
  background-color: white;
  color: #0ab1bf;
}

.el-tabs__item .is-active .is-top {
  background-color: white;
  color: #0ab1bf;
}
.el-tabs__item .is-top {
  background-color: white;
  color: #0ab1bf;
}

.el-tabs__item:hover {
  color: #0ab1bf;
}

.el-tabs__item {
  color: #184a56;
  height: auto;
  font-size: 1rem;
  line-height: 1rem;
}

</style>
